<script setup lang="ts">
import Icon from 'duanaga-icons'
import { useDialog } from 'duanaga-ui'

const { hideDialog } = useDialog()
</script>

<template>
  <button
    type="button"
    class="flex size-36 items-center justify-center rounded-full border border-grey-40/80 bg-white/80 p-8 text-grey-70 shadow-sm transition-colors duration-150 hover:text-grey-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-30"
    aria-label="Close modal"
    @click="hideDialog"
  >
    <Icon
      name="close"
      size="18"
    />
  </button>
</template>
